// InactiveVarg.tsx
import React from 'react';
import { Link } from 'react-router-dom';

interface InactiveVargProps {
  vargName: string;
}

const InactiveVarg: React.FC<InactiveVargProps> = ({ vargName }) => {
  return (
    <div>
      {vargName} registrations are not open at this time. For now, you can register for regular Yog
      Varg - <Link to="https://jsyog.org/nv">Nirogatva</Link> or{' '}
      <Link to="https://jsyog.org/py">Pakshik</Link> or contact on 9850207022, 9545723332
    </div>
  );
};

export default InactiveVarg;
